import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOfferMigrateProductionMethodOptionsQuery = createQueryHook(
  OffersApiClient.migrationToAnotherProductionMethodOptions,
  {
    queryKey: ['offerMigrateProductionMethodOptions'],
  },
)
